import api from './api';
import { Krankheit, KrankheitCreate } from '../types';

export const krankheitService = {
  list: async (jahr?: number): Promise<Krankheit[]> => {
    const params: Record<string, unknown> = {};
    if (jahr) params.jahr = jahr;
    const response = await api.get('/krankheit/', { params });
    return response.data;
  },

  listAlle: async (jahr?: number): Promise<Krankheit[]> => {
    const params: Record<string, unknown> = {};
    if (jahr) params.jahr = jahr;
    const response = await api.get('/krankheit/alle', { params });
    return response.data;
  },

  create: async (data: KrankheitCreate): Promise<Krankheit> => {
    const response = await api.post('/krankheit/', data);
    return response.data;
  },

  update: async (id: number, data: Partial<KrankheitCreate>): Promise<Krankheit> => {
    const response = await api.put(`/krankheit/${id}`, data);
    return response.data;
  },

  remove: async (id: number): Promise<void> => {
    await api.delete(`/krankheit/${id}`);
  },
};
